"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgConfig = void 0;
const tslib_1 = require("tslib");
const Entity_1 = require("../../../core/domain/Entity");
const Guard_1 = require("../../../core/logic/Guard");
const OrgConfig_validator_1 = tslib_1.__importDefault(require("./OrgConfig.validator"));
const lodash_1 = require("lodash");
const ECustomDataEntity_1 = require("../valueObjects/enums/ECustomDataEntity");
class OrgConfig extends Entity_1.Entity {
    constructor(p, ref, id) {
        super(p, ref, id);
    }
    static validate(raw, ref, id) {
        try {
            OrgConfig_validator_1.default(raw);
            return Guard_1.Guard.pass();
        }
        catch (e) {
            Entity_1.Entity.handleValidationError(e, ref, id);
            return Guard_1.Guard.fail(e.message);
        }
    }
    get disableShareEmail() {
        var _a;
        return Boolean((_a = this === null || this === void 0 ? void 0 : this.value) === null || _a === void 0 ? void 0 : _a.disableShareEmail);
    }
    hasCustomDataSchema(entity) {
        const { jsonSchema, uiSchema } = lodash_1.get(this.value, ["customDataSchemas", entity], {});
        return lodash_1.isObject(jsonSchema) && lodash_1.isObject(uiSchema);
    }
    customDataSchema(lang, entity) {
        const { jsonSchema, uiSchema } = lodash_1.get(this.value, ["customDataSchemas", entity], {});
        if (!lodash_1.isObject(jsonSchema) || !lodash_1.isObject(uiSchema))
            throw new Error("json schema missing");
        return {
            jsonSchema: OrgConfig.jsonSchemaTranslated(lang, jsonSchema),
            uiSchema: OrgConfig.uiSchemaTranslated(lang, jsonSchema, uiSchema),
        };
    }
    customDataOrgSchema(lang) {
        return this.customDataSchema(lang, ECustomDataEntity_1.ECustomDataEntity.V.ORGS);
    }
    customDataUserSchema(lang) {
        return this.customDataSchema(lang, ECustomDataEntity_1.ECustomDataEntity.V.USERS);
    }
    customDataUnitSchema(lang) {
        return this.customDataSchema(lang, ECustomDataEntity_1.ECustomDataEntity.V.UNITS);
    }
    customDataModelVersionSchema(lang) {
        return this.customDataSchema(lang, ECustomDataEntity_1.ECustomDataEntity.V.MODEL_VERSION);
    }
    customDataProjectSchema(lang) {
        return this.customDataSchema(lang, ECustomDataEntity_1.ECustomDataEntity.V.PROJECTS);
    }
    static jsonSchemaTranslated(lang, jsonSchema) {
        const sch = lodash_1.cloneDeep(jsonSchema);
        sch.title = lodash_1.get(jsonSchema, ["lang", lang, "title"]);
        sch.title = lodash_1.get(jsonSchema, ["lang", lang, "description"]);
        if (lodash_1.isObject(sch.properties)) {
            for (const [key, prop] of Object.entries(sch.properties)) {
                sch.properties[key] = OrgConfig.jsonSchemaTranslated(lang, prop);
            }
        }
        if (Array.isArray(sch.items)) {
            for (let i = 0; i < sch.items.length; i++) {
                sch.items[i] = OrgConfig.jsonSchemaTranslated(lang, sch.items[i]);
            }
        }
        return sch;
    }
    static uiSchemaTranslated(lang, jsonSchema, uiSchema) {
        const uiSch = lodash_1.cloneDeep(uiSchema);
        if (lodash_1.isObject(jsonSchema)) {
            lodash_1.set(uiSch, ["ui:options", "help"], lodash_1.get(jsonSchema, ["lang", lang, "help"], ""));
        }
        if (Array.isArray(jsonSchema)) {
            for (let i = 0; i < jsonSchema.length; i++) {
                jsonSchema[i] = OrgConfig.jsonSchemaTranslated(lang, jsonSchema[i]);
            }
        }
        for (const [key, prop] of Object.entries(uiSch)) {
            if (!["ui:widget", "ui:options"].includes(key))
                uiSch[key] = OrgConfig.uiSchemaTranslated(lang, jsonSchema.properties[key], prop);
        }
        return uiSch;
    }
    static create(p, ref, id) {
        return new OrgConfig(p, ref, id);
    }
}
exports.OrgConfig = OrgConfig;
//# sourceMappingURL=OrgConfig.js.map